import { CustomReportVariants } from "#batteries-included-components/Layouts/CustomReport/CustomReportDetailLayout.helpers";
import { CustomReportListFilterPanel } from "#batteries-included-components/Panels/FilterPanels/CustomReportListFilterPanel";
import { CustomReportListTablePanel } from "#batteries-included-components/Panels/TablePanels/CustomReportListTablePanel";
import { useStorageKey } from "#src/hooks/useStorageKey";
import React from "react";

export const RecordCustomReportListTab = ({
  isOldSidebarLocation,
}: {
  isOldSidebarLocation?: boolean;
}) => {
  const [filterConfigStorageKey, tableConfigStorageKey, tableStateStorageKey] =
    useStorageKey(
      ["filter-configuration", "table-configuration", "table-state"],
      "records-custom-report-list"
    );

  return (
    <>
      <CustomReportListFilterPanel
        filterConfigStorageKey={filterConfigStorageKey}
      />
      <CustomReportListTablePanel
        variant={CustomReportVariants.RECORDS}
        isOldSidebarLocation={isOldSidebarLocation}
        filterConfigStorageKey={filterConfigStorageKey}
        tableConfigStorageKey={tableConfigStorageKey}
        tableStateStorageKey={tableStateStorageKey}
      />
    </>
  );
};
